<!-- P11S0 Component - Section 871(m) Covered Partnerships -->
<div class="f1065-k2-container">

  <!-- INITIAL LOADING STATE - shown when waiting for filter selection -->
  @if (loadingData) {
<div class="gg-loader">
    <div class="gg-loader-text">
      <img src="assets/img/arrow-filter-sm.png" alt="">
    </div>
  </div>
}

  <!-- MAIN CONTENT - shown after initialization -->
  @if (!loadingData) {
<div>
    
    <!-- FORM LOADER - shown while fetching data after filter selection -->
    @if (showLoader) {
<div class="form-loader">
      <div class="css-spinner"></div>
    </div>
}

    <!-- FORM CONTENT -->
    @if (!showLoader) {
<div>
    <!-- Section Header -->
    <p class="h5 section-header"><b>{{ sectionHeader }}</b></p>

    <div class="table-responsive table-container">

      <!-- SECTION 1 (UI_S1) - NUMERIC and CHK_BX using LINE_COMP -->
      <table class="table table-striped blue tbl-cus-width">
        <thead>
          <tr align="center">
            @if (showErrCol && isUIErrorSec.includes('UI_S1')) {
<th style="width: 200px;">Error</th>
}
            <th class="hd-sno" style="text-align: center">Line</th>
            <th style="text-align: center">Description</th>
            @for (cols of getColHeadersForSection('UI_S1'); track $index) {
<th
                style="width: 122px; text-align: center; vertical-align: top;">
              {{ cols.COL_DESC }} @if (cols.IS_MANDATORY === 'Y') {
<span>*</span>
}
            </th>
}
          </tr>
        </thead>
        <tbody>
          @for (x of getRowsForSection('UI_S1'); track trackByRow($index, x)) {
<tr>
            <!-- Error Column -->
            @if (showErrCol && isUIErrorSec.includes(x.LINE_SEC || '')) {
<td class="err-col">
              <div [ngClass]="x.ERR_MSG && x.ERR_MSG.length > 0 ? 'err-cell-yes' : 'err-cell-no'"
                   [innerHTML]="x.ERR_MSG"></div>
            </td>
}

            <!-- Line Number -->
            <td style="font-weight:bold; white-space: nowrap; padding-right: 5px; text-align: right;">
              @if (x.SNO === 0 && x.IS_LINE_MULTI === 'Y') {
<i
                 class="fa fa-plus-circle color-green"
                 style="font-size:24px; cursor: pointer; vertical-align: middle;"
                 ap-tooltip [tooltipContent]="'Add Row'"
                 [direction]="'top'" [appendAfterTarget]="true"
                 (click)="addRow(x)"></i>
}
              @if (x.SNO > 0) {
<i
                 class="fa fa-minus-circle color-red"
                 style="font-size:24px; cursor: pointer; vertical-align: middle;"
                 ap-tooltip [tooltipContent]="'Delete Row'"
                 [direction]="'top'" [appendAfterTarget]="true"
                 (click)="deleteRow(x)"></i>
}
              @if (x.SNO === 0) {
<span>{{ x.LINE_NO }}</span>
}
            </td>

            <!-- Description -->
            <td><p>{{ x.SNO === 0 ? x.LINE_DESC : '' }}</p></td>

            <!-- Data Columns (using LINE_COMP for UI_S1) -->
            @for (amts of x.items | orderBy:'COL_ORDER'; track trackByCol($index, amts)) {
<td
                style="height: 30px; width: 122px; text-align: right;">
              
              <!-- NUMERIC (using LINE_COMP) -->
              @if (amts.LINE_COMP === 'NUMERIC') {
<input
                     type="text"
                     class="form-control min-ele-wid"
                     [ngClass]="{
                       'custom-error': amts.IS_ERROR === 'Y',
                       'custom-textbox': amts.IS_ENABLED === 'Y'
                     }"
                     [(ngModel)]="amts.CELL_VALUE"
                     [disabled]="amts.IS_ENABLED === 'N'"
                     onlyIntegersWithLength
                     style="text-align: right;">
}

              <!-- CHECK BOX (using LINE_COMP) -->
              @if (amts.LINE_COMP === 'CHK_BX') {
<input
                     type="checkbox"
                     [(ngModel)]="amts.CELL_VALUE"
                     [ngModelOptions]="{standalone: true}"
                     [disabled]="amts.IS_ENABLED === 'N'"
                     [value]="'X'"
                     class="lg-chk"
                     (change)="amts.CELL_VALUE = $any($event.target).checked ? 'X' : ''">
}
            </td>
}
          </tr>
}
        </tbody>
      </table>

      <!-- SECTION 2 (UI_S2) - NUMERIC with totals and DATE -->
      <table class="table table-striped blue tbl-cus-width">
        <thead>
          <tr align="center">
            @if (showErrCol && isUIErrorSec.includes('UI_S2')) {
<th style="width: 200px;">Error</th>
}
            <th class="hd-sno" style="text-align: center">Line</th>
            <th style="text-align: center">Description</th>
            @for (cols of getColHeadersForSection('UI_S2'); track $index) {
<th
                style="width: 122px; text-align: center; vertical-align: top;">
              {{ cols.COL_DESC }} @if (cols.IS_MANDATORY === 'Y') {
<span>*</span>
}
            </th>
}
          </tr>
        </thead>
        <tbody>
          @for (x of getRowsForSection('UI_S2'); track trackByRow($index, x)) {
<tr>
            <!-- Error Column -->
            @if (showErrCol && isUIErrorSec.includes(x.LINE_SEC || '')) {
<td class="err-col">
              <div [ngClass]="x.ERR_MSG && x.ERR_MSG.length > 0 ? 'err-cell-yes' : 'err-cell-no'"
                   [innerHTML]="x.ERR_MSG"></div>
            </td>
}

            <!-- Line Number -->
            <td style="font-weight:bold; white-space: nowrap; padding-right: 5px; text-align: right;">
              @if (x.SNO === 0 && x.IS_LINE_MULTI === 'Y') {
<i
                 class="fa fa-plus-circle color-green"
                 style="font-size:24px; cursor: pointer; vertical-align: middle;"
                 ap-tooltip [tooltipContent]="'Add Row'"
                 [direction]="'top'" [appendAfterTarget]="true"
                 (click)="addRow(x)"></i>
}
              @if (x.SNO > 0) {
<i
                 class="fa fa-minus-circle color-red"
                 style="font-size:24px; cursor: pointer; vertical-align: middle;"
                 ap-tooltip [tooltipContent]="'Delete Row'"
                 [direction]="'top'" [appendAfterTarget]="true"
                 (click)="deleteRow(x)"></i>
}
              @if (x.SNO === 0) {
<span>{{ x.LINE_NO }}</span>
}
            </td>

            <!-- Description -->
            <td><p>{{ x.SNO === 0 ? x.LINE_DESC : '' }}</p></td>

            <!-- Data Columns -->
            @for (amts of x.items | orderBy:'COL_ORDER'; track trackByCol($index, amts)) {
<td
                style="height: 30px; width: 122px; text-align: right;">
              
              <!-- NUMERIC with change handler for totals (4 decimal places) -->
              @if (amts.UI_COMP === 'NUMERIC') {
<input
                     type="text"
                     class="form-control min-ele-wid"
                     [ngClass]="{
                       'custom-error': amts.IS_ERROR === 'Y',
                       'custom-textbox': amts.IS_ENABLED === 'Y'
                     }"
                     [(ngModel)]="amts.CELL_VALUE"
                     [disabled]="amts.IS_ENABLED === 'N'"
                     [readonly]="isLastNumericColumn(x.items, amts)"
                     onlyDigitsDecimalWithLength
                     [decimalDigits]="4"
                     (ngModelChange)="calcTotalsCol(x.items)"
                     style="text-align: right;">
}

              <!-- DATE: ENABLED -->
              @if (amts.UI_COMP === 'DATE' && amts.IS_ENABLED !== 'N') {
<div class="input-group">
                <input type="date"
                       class="form-control min-ele-wid"
                       [ngClass]="{
                         'custom-error': amts.IS_ERROR === 'Y',
                         'custom-textbox': amts.IS_ENABLED === 'Y'
                       }"
                       [ngModel]="amts.CELL_VALUE | date:'yyyy-MM-dd'"
                       (ngModelChange)="onDateChange(amts, $event)"
                       style="font-size: 11px;">
              </div>
}

              <!-- DATE: DISABLED -->
              @if (amts.UI_COMP === 'DATE' && amts.IS_ENABLED === 'N') {
<div class="input-group">
                <input type="date"
                       class="form-control min-ele-wid"
                       [ngModel]="amts.CELL_VALUE | date:'yyyy-MM-dd'"
                       disabled
                       style="font-size: 11px;">
              </div>
}
            </td>
}
          </tr>
}
        </tbody>
      </table>

    </div>

    <!-- Action Buttons -->
    @if (isAdmin) {
<div class="k2-buttons-container">
      <button class="save-button" type="button" (click)="save()" [disabled]="isSaveClicked">Save</button>
      <button class="reset-button" type="button" (click)="reset()" [disabled]="!isAdmin">Reset</button>
    </div>
}
    </div>
} <!-- closes content -->
  </div>
} <!-- closes !loadingData -->
</div> <!-- closes f1065-k2-container -->

<!-- Confirmation Modal -->
@if (showConfirmModal) {
<div class="confirmation-modal-overlay">
  <gtw-confirmation-modal
    [config]="confirmModalConfig"
    [visible]="false"
    (confirmed)="onSaveConfirm()"
    (cancelled)="onSaveCancel()"
    (closed)="onSaveCancel()">
  </gtw-confirmation-modal>
</div>
}
